<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-40" @mousedown="dontClose">
          <div class="modal-body m-0" style="overflow-y: auto;" :style="{maxHeight: getMaxHeightClient() + 'px'}">
            <div slot="formcontent" style="margin: 0px 20px 0px 20px;">
              <b-row>
                <b-col style="text-align:end;">
                  <i class="fa fa-times close-button" style="font-size:20px" @click="handleMouseDown"></i>
                </b-col>
              </b-row>
              <b-row class="panel-heading">
                <b-col cols="12" class="formTitleBlock">
                  <h4 class="content-block labelAccordionForm">
                    <i class="fa-light fa-file-code mr-2" style="font-size: 20px"></i>
                    {{ $t('common.rvk_trnsctn') }}
                  </h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col v-if="norm === '1'" sm="12" md="10" lg="12" xl="10">
                  <select class="refusedReasonCode form-group" style="width:100%" v-model="reasonCode">
                    <option value="AM09">{{ $t('requestToPay.wrng_amnt') }}</option>
                    <option value="AM05">{{ $t('requestToPay.dupplicate') }}</option>
                    <option value="AM03">{{ $t('requestToPay.wrng_crrncy') }}</option>
                    <option value="IEDT">{{ $t('requestToPay.wrng_expiry_date') }}</option>
                    <option value="MS02">{{ $t('requestToPay.empty_reason') }}</option>
                    <option value="NOAR">{{ $t('requestToPay.no_agreement') }}</option>
                    <option value="UCRD">{{ $t('requestToPay.unknown_creditor') }}</option>
                    <option value="OTHER">{{ $t('requestToPay.othr_rsn') }}</option>
                  </select>
                  <input v-if="reasonCode === 'OTHER'" class="commentTextArea refusedReasonLabel border-0 p-0" maxlength="35" isMandatory v-model="reasonLabel" :placeholder="$t('requestToPay.othr_rsn_val_SRTP')" />
                </b-col>
                <b-col v-if="norm === '2'" sm="10" md="8" lg="10" xl="8">
                  <input class="refusedReasonLabel commentTextArea border-0 p-0" maxlength="105" isMandatory v-model="reasonLabel" :placeholder="$t('requestToPay.othr_rsn_val_HRTP')" />
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="modal-footer">
            <b-col cols="6" sm="4" md="3" lg="3" xl="3" class="p-0 m-0">
              <b-button variant="primary" :disabled="!reasonCode"
                @click="selectReasonCode()">
                {{ $t('common.refus') }}
              </b-button>
            </b-col>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'ChoicePaymentRefuse',
  props: {
    data: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      mousedown: false,
      norm: this.data,
      reasonCode: 'AM09',
      reasonLabel: ''
    }
  },
  created () {
    window.addEventListener('resize', this.changeMaxHeightClient)
    window.addEventListener('mousedown', this.handleMouseDown)
    window.addEventListener('mouseup', this.handleMouseUp)
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  methods: {
    changeMaxHeightClient () {
      let maxHeight = document.querySelector('body').clientHeight
      document.querySelector('.modal-container').setAttribute('style', 'overflow-y:auto;max-height: ' + maxHeight + 'px')
    },
    dontClose (e) {
      e.stopPropagation()
    },
    getMaxHeightClient () {
      return document.querySelector('body').clientHeight
    },
    handleMouseDown (e) {
      if (!this.mousedown) {
        if (e.target.closest('.modal-mask') || e.target.closest('.close-button')) {
          this.$emit('close')
        }
        this.mousedown = true
      }
    },
    handleMouseUp () {
      this.mousedown = false
    },
    selectReasonCode () {
      let that = this

      this.$emit('close')
      if (this.norm === '2') {
        this.$f7.modal({
          title: that.$i18n.t('common.refus_hrtp'),
          text: that.$i18n.t('common.action_question'),
          buttons: [{
            text: that.$t('administration.no'),
            onClick: that.$f7.closeModal()
          }, {
            text: that.$t('administration.yes'),
            onClick: function () {
              that.$bus.$emit('answer-to-payments', {
                status: '11',
                optionals: {
                  reasonType: that.reasonCode,
                  reason: that.reasonCode === 'OTHER' || that.norm === '2' ? that.reasonLabel : undefined
                }
              })
            }
          }]
        })
      } else {
        that.$bus.$emit('answer-to-payments', {
          status: '11',
          optionals: {
            reasonType: that.reasonCode,
            reason: that.reasonCode === 'OTHER' || that.norm === '2' ? that.reasonLabel : undefined
          }
        })
      }
    }
  }
}
</script>
<style scoped>
</style>
